import Selector from "./Selector";
export const languages = [
  { title: "EN", value: "en" },
  { title: "UA", value: "ua" },
  { title: "RU", value: "ru" },
];

export default function LanguageSelector({ language, setLanguage }) {
  return (
    <Selector
      options={languages}
      value={language.toUpperCase()}
      onChange={(value) => {
        setLanguage(value.toLowerCase());
      }}
      className="language"
    />
  );
}
